import { api, clearCsrfToken, ensureCsrfToken } from './http'
import type { AccountAccessInviteActivationCommand, AccountAccessInvitePreview, AuthPasswordChangeCommand, AuthSession } from './types'

export const authApi = {
  csrf: () => ensureCsrfToken(),
  me: (signal?: AbortSignal) => api.get<AuthSession>('/auth/me', undefined, signal),
  login: async (email: string, password: string) => {
    await ensureCsrfToken()
    const session = await api.post<AuthSession>('/auth/login', { email, password })
    clearCsrfToken()
    return session
  },
  accessInvite: (token: string, signal?: AbortSignal) =>
    api.get<AccountAccessInvitePreview>(`/auth/access-invites/${encodeURIComponent(token)}`, undefined, signal),
  activateInvite: async (token: string, command: AccountAccessInviteActivationCommand) => {
    await ensureCsrfToken()
    const session = await api.post<AuthSession>(`/auth/access-invites/${encodeURIComponent(token)}/activate`, command)
    clearCsrfToken()
    return session
  },
  logout: async () => {
    await api.post<void>('/auth/logout')
    clearCsrfToken()
  },
  changePassword: async (command: AuthPasswordChangeCommand) => {
    await api.post<void>('/auth/password', command)
    clearCsrfToken()
  },
}
